import type { LucideIcon } from "lucide-react";
import {
  Zap,
  Truck,
  Landmark,
  HeartPulse,
  Droplets,
  Waves,
  Server,
  Building2,
  Orbit,
  Mail,
  Recycle,
  FlaskConical,
  Wheat,
  Factory,
  Globe,
  Microscope,
  Layers,
} from "lucide-react";

const SECTOR_ICONS: Record<string, LucideIcon> = {
  energy: Zap,
  transport: Truck,
  financial: Landmark,
  health: HeartPulse,
  "drinking-water": Droplets,
  "waste-water": Waves,
  "digital-infra": Server,
  "public-admin": Building2,
  space: Orbit,
  postal: Mail,
  "waste-mgmt": Recycle,
  chemicals: FlaskConical,
  food: Wheat,
  manufacturing: Factory,
  "digital-providers": Globe,
  research: Microscope,
};

export function getSectorIcon(cod: string): LucideIcon {
  return SECTOR_ICONS[cod] ?? Layers;
}
